<template>
  <v-autocomplete
      :error-messages="error"
      variant="outlined"
      rounded="lg"
      bg-color="surface"
      :label="translation(translationList.continent, 'Continent')"
      :items="continents"
      item-title="name"
      name="continent"
      item-value="id"
      v-model="selectedContinent"
      :loading="loading"
      :disabled="loading"
      :rules="[v => !!v || translation(translationList.required, 'Acest câmp este obligatoriu')]"
      return-object
  >
  </v-autocomplete>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, toRefs, watch } from 'vue';
import { useAddressStore } from '~/plugins/store/address';
import { useTranslationStore, translation } from '~/plugins/store/translations';
import type { Continent } from '~/types/Address';
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  props: {
    modelValue: {
      type: Object as () => Continent | null,
      default: () => null,
      required: false
    },
  },
  emits: ['update:modelValue', 'validation-address-status'],
  setup(props, { emit }) {
    const { modelValue } = toRefs(props);
    const addressStore = useAddressStore();
    const translationStore = useTranslationStore();
    const selectedContinent = ref(modelValue.value ? modelValue.value : null);
    const continents = ref<Continent[]>([]);
    const translationList = ref<TranslationList>({});
    let initialSetupDone = false;
    const error = ref([]);
    const loading = ref(false);

    onMounted(async () => {
      loading.value = true;
      continents.value = await addressStore.getContinents();
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
      initialSetupDone = true;
      const isValid = !!selectedContinent.value;
      emit('validation-address-status', { field: 'continent', isValid });
      loading.value = false;

      window.addEventListener('validate-address', handleValidationEvent);
      window.addEventListener('validate-travel', handleValidationEvent);
    });

    const handleValidationEvent = (data: any) => {
      if (data.detail && data.detail === 'continent') {
        if (!selectedContinent.value) {
          error.value.push(translation(translationList.value.required, 'Acest câmp este obligatoriu'));
        } else {
          error.value = [];
          emit('validation-address-status', { field: 'continent', isValid: true });
        }
      }
    };

    watch(selectedContinent, (newContinent) => {
      if (initialSetupDone) {
        emit('update:modelValue', newContinent);
      }
    });

    watch(modelValue, (newValue) => {
      error.value = [];
      if (newValue) {
        selectedContinent.value = newValue;
      }
      const isValid = !!newValue;
      emit('validation-address-status', { field: 'continent', isValid });
    });

    return {
      selectedContinent,
      translationList,
      translation,
      continents,
      error,
      loading
    };
  },
});
</script>

<style scoped>
</style>
